import { css } from "styled-components"

export const title3 = css`
  font-size: ${({ theme }) => theme.font.size.title3};
  line-height: 1.33;
  font-weight: normal;
`

export const title3Bold = css`
  ${title3}
  font-weight: ${({ theme }) => theme.font.weight.bold};
  ${({ theme }) => theme.media.tablet`
    font-family: ${({ theme }) => theme.font.family.desktop.bold};
    font-weight: normal;
  `}
`
